import { z } from 'zod';
const shortString = z.string().min(1).max(400);
const lineString = z.string().min(1).max(800);
export const governDemoPolicyContextSchema = z.object({
    surface: z.literal('policy_context'),
    fixture_version: shortString,
    headline: shortString,
    summary_lines: z.array(lineString).min(1).max(24),
    review_standards_hint: z.string().max(800).nullable().optional(),
});
export const governDemoAiControlDimensionSchema = z.object({
    key: z.string().min(1).max(64),
    label: z.string().min(1).max(200),
    effective_summary: z.string().min(1).max(1200),
    presentation: z.enum(['demo_locked', 'customer_representative']),
});
export const governDemoAiControlsSchema = z.object({
    surface: z.literal('ai_controls'),
    fixture_version: shortString,
    dimensions: z.array(governDemoAiControlDimensionSchema).min(3).max(24),
});
export const governDemoAuditPostureSchema = z.object({
    surface: z.literal('audit_posture'),
    fixture_version: shortString,
    auditable_categories: z.array(z.string().min(1).max(200)).min(1).max(32),
    reviewer_roles_summary: z.array(z.string().min(1).max(400)).min(1).max(16),
    retention_summary: z.string().min(1).max(2000),
});
export const governDemoHybridComparisonPointSchema = z.object({
    facet: z.string().min(1).max(200),
    customer_managed: z.string().min(1).max(1200),
    vendor_operated: z.string().min(1).max(1200),
});
export const governDemoHybridWorkerByoSchema = z.object({
    surface: z.literal('hybrid_worker_byo'),
    fixture_version: shortString,
    positioning_headline: shortString,
    comparison_points: z.array(governDemoHybridComparisonPointSchema).min(1).max(16),
});
export const governDemoSurfaceKeySchema = z.enum([
    'policy_context',
    'ai_controls',
    'audit_posture',
    'hybrid_worker_byo',
]);
//# sourceMappingURL=govern-demo.js.map